import React, { useRef, useEffect, useState } from 'react';

const Navigation = ({ activeTab, setActiveTab, isAdmin }) => {
    const navRef = useRef(null);
    const [showScrollIndicator, setShowScrollIndicator] = useState(false);

    // Проверка необходимости индикатора прокрутки
    useEffect(() => {
        const checkForScrollbar = () => {
            if (navRef.current) {
                // Если контент шире контейнера, нужен индикатор
                setShowScrollIndicator(
                    navRef.current.scrollWidth > navRef.current.clientWidth
                );
            }
        };

        // Проверяем при монтировании и при изменении размера окна
        checkForScrollbar();
        window.addEventListener('resize', checkForScrollbar);

        return () => {
            window.removeEventListener('resize', checkForScrollbar);
        };
    }, []);

    // Прокручиваем к активному табу
    useEffect(() => {
        if (navRef.current && activeTab) {
            // Находим активную кнопку
            const activeButton = navRef.current.querySelector(`button.active`);

            if (activeButton) {
                // Получаем положение элемента относительно родителя
                const buttonOffset = activeButton.offsetLeft;
                const buttonWidth = activeButton.offsetWidth;
                const navWidth = navRef.current.offsetWidth;

                // Прокручиваем, чтобы активный элемент был по центру, если возможно
                navRef.current.scrollLeft = buttonOffset - (navWidth / 2) + (buttonWidth / 2);
            }
        }
    }, [activeTab]);

    return (
        <nav className="nav-desktop">
            <ul className="nav-list" ref={navRef}>
                <li>
                    <button
                        className={activeTab === 'home' ? 'active' : ''}
                        onClick={() => setActiveTab('home')}
                    >
                        Главная
                    </button>
                </li>
                <li>
                    <button
                        className={activeTab === 'catalog' ? 'active' : ''}
                        onClick={() => setActiveTab('catalog')}
                    >
                        Каталог
                    </button>
                </li>
                <li>
                    <button
                        className={activeTab === 'services' ? 'active' : ''}
                        onClick={() => setActiveTab('services')}
                    >
                        Услуги
                    </button>
                </li>
                <li>
                    <button
                        className={activeTab === 'about' ? 'active' : ''}
                        onClick={() => setActiveTab('about')}
                    >
                        О нас
                    </button>
                </li>
                <li>
                </li>
                {isAdmin && (
                    <li>
                        <button
                            className={activeTab === 'admin' ? 'active' : ''}
                            onClick={() => setActiveTab('admin')}
                        >
                            Админ-панель
                        </button>
                    </li>
                )}
            </ul>
            {showScrollIndicator && <div className="nav-scroll-indicator"></div>}
        </nav>
    );
};

export default Navigation;